import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FadeIn } from './ui/FadeIn';
export function Footer() {
  const navigate = useNavigate();
  return <footer className="bg-neutral-950 border-t border-neutral-900 pt-24 pb-12 relative overflow-hidden" data-id="element-37">
      {/* Subtle red glow at the bottom */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[200px] bg-red-600/5 blur-[120px] pointer-events-none" data-id="element-38" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-39">
        <FadeIn data-id="element-40">
          <div className="flex flex-col items-center text-center mb-24" data-id="element-41">
            <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase mb-8 max-w-3xl" data-id="element-42">
              Si querés un sistema y acompañamiento real, empezá por la
              Mentoría.
            </h2>
            <div className="flex flex-col items-center gap-4 w-full sm:w-auto" data-id="element-43">
              <button onClick={() => navigate('/mentoria')} className="bg-red-600 hover:bg-red-500 text-white font-bold py-4 px-10 rounded-sm transition-all text-center uppercase tracking-wider text-sm shadow-[0_0_20px_rgba(220,38,38,0.2)] cursor-pointer" data-id="element-44">
                Ver Mentoría
              </button>
            </div>
          </div>
        </FadeIn>

        <div className="border-t border-neutral-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-45">
          <div className="text-white font-black tracking-[0.2em] text-lg uppercase flex items-center gap-2" data-id="element-46">
            <span className="w-2 h-2 bg-red-600 rounded-sm" data-id="element-47"></span>
            PROTOCOLO SNIPER
          </div>

          <div className="text-xs text-neutral-500 max-w-2xl text-center md:text-right leading-relaxed" data-id="element-48">
            <p data-id="element-49">
              Contenido estrictamente educativo. No es asesoramiento financiero.
            </p>
            <p data-id="element-50">
              Operar en los mercados financieros conlleva un alto riesgo. Los
              resultados varían según cada individuo.
            </p>
            <p className="mt-2" data-id="element-51">
              © {new Date().getFullYear()} Protocolo Sniper. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}